
<nav class="fixed w-full z-20 top-0 left-0 shadow-xl bg-primary-dark-2 border-zinc-300 border-b-2">
  <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-2">
    <a routerLink="" class="flex items-center space-x-2 rtl:space-x-reverse">
      <img src="logo.png" class="h-11" alt="ACM JUSC Logo" />
      <span class="text-white self-center text-xl font-semibold whitespace-nowrap">The Byte Magazine</span>
    </a>
    <button type="button"
            class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white rounded-lg md:hidden hover:bg-secondary hover:text-white focus:outline-none focus:ring-2 focus:ring-gray-200"
            (click)="isMenuOpen = !isMenuOpen" [attr.aria-expanded]="isMenuOpen">
      <span class="sr-only">Open main menu</span>
      <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15" />
      </svg>
    </button>
    <div [class]="{'hidden': !isMenuOpen, 'flex': isMenuOpen}"
         class="items-center justify-between font-medium w-full md:flex md:w-auto md:order-1">
      <ul class="flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0">
        @for (item of headerItems; track $index) {
        <li class="flex items-center">
          <a [routerLink]="item.link" class="nav-link block text-white hover:text-blue-100 py-2 px-3 md:p-0 relative"
             aria-current="page">
            {{ item.text }}
          </a>
        </li>
        }


        <li class="flex items-center">
          <a routerLink="/"
             class="navbar-action-button text-white bg-secondary hover:scale-105 transition ease-in-out duration-300 font-medium rounded-md px-5 py-1 text-center mt-4 md:mt-0">
            Join Us
          </a>
        </li>

      </ul>
    </div>
  </div>
</nav>
